module.exports = __webpack_public_path__ + "img/2.b1905829.jpg";